import React from 'react';

export const clientCommandStatusTone = (status) => {
  const normalized = String(status || '').trim().toLowerCase();

  if (!normalized
    || /(unknown|pending|awaiting|queued|not started|not checked|not run|not tested|in progress|draft|skipped)/.test(
      normalized,
    )) {
    return 'neutral';
  }
  if (/(error|fail|invalid|unavailable|not available|blocked|offline|access denied)/.test(
    normalized,
  )) {
    return 'error';
  }
  if (/(warning|needs attention|empty|incomplete|inactive|disabled|missing|required|not configured|not ready|not enabled|not valid|not loaded|cancelled|rollback required)/.test(
    normalized,
  )) {
    return 'warning';
  }
  if (/(active|complete|configured|loaded|ready|enabled|healthy|online|success|passed|valid|resolved|available|prepared|provisioned|initialized|dedicated client partition)/.test(
    normalized,
  )) {
    return 'success';
  }
  return 'neutral';
};

const ClientCommandStatusTag = ({
  status,
  tone,
  className = '',
}) => {
  const displayStatus = String(status || '').trim();
  if (!displayStatus) return null;
  const resolvedTone = ['neutral', 'error', 'warning', 'success'].includes(tone)
    ? tone
    : clientCommandStatusTone(displayStatus);

  return (
    <span
      className={[
        'resource-workspace-status-pill',
        'client-command-status-tag',
        `resource-workspace-status-pill--${resolvedTone}`,
        className,
      ].filter(Boolean).join(' ')}
    >
      {displayStatus}
    </span>
  );
};

export default ClientCommandStatusTag;
